import { render, staticRenderFns } from "./LinkedTTH.vue?vue&type=template&id=8cecc5c6&scoped=true&"
import script from "./LinkedTTH.vue?vue&type=script&lang=ts&"
export * from "./LinkedTTH.vue?vue&type=script&lang=ts&"
import style0 from "./LinkedTTH.vue?vue&type=style&index=0&id=8cecc5c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cecc5c6",
  null
  
)

export default component.exports